//console.log('main.js');

//Toggle Chat
let chatBtn = document.querySelector("#toggle-chat-btn");

chatBtn.addEventListener("click", function (event) {
  event.preventDefault();
  chatBtn.classList.add("active");
  document.querySelector("#shopify-chat").classList.toggle("active");
  // document.querySelector("#ShopifyChat").dataset.isOpen = "true";
  document.getElementById("ShopifyChat").shadowRoot.querySelector("button.chat-toggle").click();
});

//Desktop Close Button
function startCheckingForDesktopButton() {
  const intervalId = setInterval(() => {
    //console.log("Checking for desktop chat close button...");
    const shopifyChatElement = document.getElementById("ShopifyChat");

    if (shopifyChatElement && shopifyChatElement.shadowRoot) {
      const closeButton = shopifyChatElement.shadowRoot.querySelector('button[aria-label="Chat window"]');
  
      if (closeButton) {
        closeButton.style.cssText = " opacity: 0;";
        //clearInterval(intervalId);
      }
    }
  }, 50);
}

startCheckingForDesktopButton();

//Mobile Close Button
function startCheckingForButton() {
  const intervalId = setInterval(() => {
    //console.log("Checking for chat close button...");

    const shopifyChatElement = document.getElementById("ShopifyChat");
    if (shopifyChatElement && shopifyChatElement.shadowRoot) {
      const closeButton = shopifyChatElement.shadowRoot.querySelector('button[aria-label="Close chat window"]');
      
      if (closeButton) {
        closeButton.addEventListener("click", function (event) {
          document.querySelector("#shopify-chat").classList.remove("active");
          startCheckingForButton();
        });
        //clearInterval(intervalId);
      }
    }
  }, 50);
}

startCheckingForButton();


window.addEventListener("resize", function () {
  //Auto Heights
  let trueHeight = window.innerHeight;
  let setHeights = document.querySelectorAll(".auto-height");
  setHeights.forEach(function (item, i) {
    item.style.height = trueHeight + "px";
  });
});

document.addEventListener("DOMContentLoaded", function () {
  //Auto Heights
  let trueHeight = window.innerHeight;
  let setHeights = document.querySelectorAll(".auto-height");
  setHeights.forEach(function (item, i) {
    item.style.height = trueHeight + "px";
  });


  //Popups
  let sidePops = document.querySelectorAll(".side-pop");
  let closePops = document.querySelectorAll(".close-pop");
  let sidePopCloseBg = document.querySelector("#pop-bg");

  closePops.forEach(function (item, i) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      closeSidePops();
      //resetLogin();
    });
  });

  let closeSidePops = function () {
    sidePops.forEach(function (item) {
      item.classList.remove("active");
    });
    sidePopCloseBg.classList.remove('active');
  };

  //Contact Buttons
  let contactBtns = document.querySelectorAll(".contact-btn");
  let contactPopup = document.querySelector("#side-contact");
  contactBtns.forEach(function (item, i) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      contactPopup.classList.add("active");
      sidePopCloseBg.classList.add("active");
    });
  });

  //Sidepop BG Close
  sidePopCloseBg.addEventListener('click', function(event){
    event.preventDefault();
    closeSidePops();
  });

  //Mobile Nav Button
  let menuBtn = document.querySelector("#menu-btn");
  let mobileNav = document.querySelector("#mobile-nav");
  let siteBody = document.querySelector("body");
  let headerNav = document.querySelector("header");

  menuBtn.addEventListener("click", function (event) {
    event.preventDefault();
    menuBtn.classList.toggle("active");
    headerNav.classList.toggle("white");
    mobileNav.classList.toggle("active");
    siteBody.classList.toggle("no-scroll");
  });

  //Page Head
  let pageHead = document.querySelector(".page-head");
  if (pageHead) {
    let readBtn = pageHead.querySelector(".read-more");
    if (readBtn) {
      let short = pageHead.querySelector(".short");
      let full = pageHead.querySelector(".full");
      readBtn.addEventListener("click", function (event) {
        event.preventDefault();
        readBtn.classList.add("hide");
        short.classList.add("hide");
        full.classList.remove("hide");
      });
    }
  }

  //Cart Button
  let cartBtn = document.querySelectorAll('.cart-btn');
  let sideCart = document.querySelector('#side-cart');
  cartBtn.forEach(function(item){
    item.addEventListener('click', function(event){
      event.preventDefault();
      sideCart.classList.add('active');
      sidePopCloseBg.classList.add("active");
    });
  });

  //Search Button
  let searchBtn = document.querySelectorAll('.search-btn');
  let searchCon = document.querySelector('#search-header');
  let closeSearchBtn = document.querySelectorAll('.close-search-btn');

  searchBtn.forEach(function(item){
    item.addEventListener("click", function (event) {
      event.preventDefault();
      //console.log("Search Header");
      searchCon.classList.toggle("open");
      searchCon.querySelector('#search-input').focus();
    });
  });

  closeSearchBtn.forEach(function(item){
    item.addEventListener("click", function (event) {
      event.preventDefault();
      //console.log("Close Seach");
      document.querySelector("#search-input").value = "";
      document.querySelector("#search-results").innerHTML = "";
      document.querySelector("#showing-top-results").classList.add("hide");
      document.querySelector("#show-more").classList.add("hide");
      searchCon.classList.remove("open");
    });
  });

  //Non recurring membership button
  let membershipBtn = document.querySelectorAll(".upsell-btn");
  if (membershipBtn.length > 0) {
    membershipBtn.forEach(function (item) {
      item.addEventListener("click", function (event) {
        event.preventDefault();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: 45437566025974,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Item added to cart!', data);
          document.querySelector("#side-cart").classList.add("active");
          displayCart();
        })
        .catch(error => console.error('Error adding item to cart:', error));
      });
    });
  }

  //Recurring Membership Button
  let recurringMembershipBtn = document.querySelectorAll(".recurring-upsell-btn");
  if (recurringMembershipBtn.length > 0) {
    recurringMembershipBtn.forEach(function (item) {
      item.addEventListener("click", function (event) {
        event.preventDefault();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: 46021519376630,
            quantity: 1,
            selling_plan: 3454730486
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Item added to cart!', data);
          document.querySelector("#side-cart").classList.add("active");
          displayCart();
        })
        .catch(error => console.error('Error adding item to cart:', error));
      });
    });
  }
});

//Dummy Btn
let dummyBtn = document.querySelectorAll(".dummy-btn");
dummyBtn.forEach(function (item) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
  });
});

//Mobile Block Menus
let menuBtns = document.querySelectorAll(".mobile-menu-btn");
let menuBlocks = document.querySelectorAll(".mobile-menu-block");

menuBtns.forEach(function (item, i) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
    resetMenus(i);
    menuBtns[i].classList.add("active");
    menuBlocks[i].classList.add("active");
  });
});

let resetMenus = function (i) {
  let menuBtns = document.querySelectorAll(".mobile-menu-btn");
  let menuBlocks = document.querySelectorAll(".mobile-menu-block");
  menuBlocks.forEach(function (item, j) {
    if (i !== j) {
      item.classList.remove("active");
      menuBtns[j].classList.remove("active");
    }
  });
}

//Search Count
let searchCount = document.querySelector("#search-results span");

if(searchCount){
  let realCount = document.querySelector("#real-count").innerHTML;
  searchCount.innerHTML = realCount;
}

//Colelctions Mobile NAv Drop
let collectionsDropBtn = document.querySelector(".collections-drop-btn");
let collectionLinks = document.querySelectorAll(".collections-link");

collectionsDropBtn.addEventListener("click", function (event) {
  event.preventDefault();
  collectionLinks.forEach(function (item) {
    item.classList.add("show");
  });
});

//Newsletter
let newsletterFormWrap = document.querySelectorAll('.newsletter-form');

if (newsletterFormWrap.length > 0) {
  newsletterFormWrap.forEach(function (item) {
    let newsletterForm = item.querySelector('form');
    let newsletterEmail = item.querySelector('.newsletter-email');
    let successMessage = item.querySelector('.success');

    newsletterForm.addEventListener('submit', function (event) {
      event.preventDefault();

      const emailValue = newsletterEmail.value;

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailValue,
                  properties: {
                    "website-source": "email-capture-footer"
                  }    
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "SZjQND ",
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify(payload),
      };

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=YB3duh', requestOptions)
        .then((res) => {
          if (res.ok) {
            // Check if there is content to parse
            return res.text().then((text) => (text ? JSON.parse(text) : {}));
          } else {
            return res.json().then((errorDetails) => {
              throw new Error(`Failed to subscribe: ${errorDetails.message}`);
            });
          }
        })
        .then((res) => {
          console.log('Submission successful:', res);
          newsletterForm.classList.add('hide');
          successMessage.classList.remove('hide');
        })
        .catch((err) => {
          console.error('Error occurred:', err);
          //successMessage.classList.add('hide');
        });
    });
  });
}

//Country Select

// let sideCountry = document.querySelector("#side-country");
// let countrySelect = document.querySelector("#country-selector");

// if (countrySelect) {
//   countrySelect.addEventListener("click", function (event) {
//     event.preventDefault();
//     sideCountry.classList.toggle("active");
//   });
// }

document.addEventListener("DOMContentLoaded", () => {
  const selectors = document.querySelectorAll('.md-footer-selector__content .md-form__select, .md-footer-selector__content .md-form__select__country__list, .md-footer-selector__content .md-form__select__language__list');

  selectors.forEach(el => {
    el.style.setProperty('border', '1px solid #eee', 'important');
  });

  const selectWithArrow = document.querySelectorAll('.md-footer-selector__content .md-form__select');

  selectWithArrow.forEach(el => {
    el.style.setProperty('background-image', 'url(https://cdn.shopify.com/s/files/1/0024/3918/4502/files/arrow-down.jpg?v=1746037711)', 'important');
  });
});


//Banner
document.addEventListener('DOMContentLoaded', function () {
  var verticalSwiperEl = document.querySelector('.banner-swiper');

  if (verticalSwiperEl) {
    new Swiper(verticalSwiperEl, {
      direction: 'vertical',
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      allowTouchMove: false,
    });
  }
});
